import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {map, Observable, tap} from "rxjs";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import { HttpClient } from "@angular/common/http";
import {imageOverlay} from "leaflet";

@Component({
  selector: 'sharedm-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageModalComponent {

  image?: any;
  isLoading = true;
  // private zoomLevel = 1;

  // get scale(): string {
  //   return ` scale(${this.zoomLevel})`;
  // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public imageUrl: string,
    private matDialogRef: MatDialogRef<ImageModalComponent>,
    private httpClient: HttpClient,
    private domSanitizer: DomSanitizer
  ) {
    this.transform(imageUrl);
  }

  transform(url: string) {
     this.httpClient.get(url, {responseType: 'blob'}).subscribe({
       next: (imageAsBase64) => {
         this.image = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageAsBase64));
         this.isLoading = false;
       },
     });
  }

  onClose() {
    this.matDialogRef.close();
  }

  // onZoomIn() {
  //   this.zoomLevel++;
  // }
  //
  // onZoomOut() {
  //   if (this.zoomLevel > 1)
  //     this.zoomLevel--;
  //   else if (this.zoomLevel > 0.1)
  //     this.zoomLevel = this.zoomLevel - 0.1;
  // }
}
